import { render } from "./CxDhScaleLegend.vue?vue&type=template&id=bf365690"
import script from "./CxDhScaleLegend.vue?vue&type=script&lang=js"
export * from "./CxDhScaleLegend.vue?vue&type=script&lang=js"

import "./CxDhScaleLegend.vue?vue&type=style&index=0&id=bf365690&lang=less"

import exportComponent from "/home/ec2-user/workspace/_ui2_staging_ui2-staging-0.124.0/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__